export default {
    computed: {
        title() {
            if (this.$route.name === 'product-sales') {
                return 'Molimo Vas za potvrdu akcije';
            }

            if (this.$route.name === 'gift-sales') {
                return 'Molimo Vas za potvrdu akcije';
            }


            if (this.$route.name === 'promotion-completion') {
                return 'Molimo Vas za potvrdu akcije';
            }

            if (this.$route.name === 'promotion-completion-dermo') {
                return 'Molimo Vas za potvrdu akcije';
            }

            if (this.$route.name === 'new-promotion-base-settings-promo') {
                return 'Fotografija je obavezna';
            }

            return 'Molim, potvrdite akciju.';
        },
        description() {
            if (this.$route.name === 'product-sales') {
                return 'Da li želite da sačuvate promenu broja prodatih preparata?';
            }

            if (this.$route.name === 'gift-sales') {
                return 'Da li želite da sačuvate promenu broja prodatih poklona?';
            }

            if (this.$route.name === 'promotion-completion') {
                return 'Da li želite da pošaljete izveštaj i završite promociju? Naknadne izmene podataka neće biti moguće.';
            }

            if (this.$route.name === 'promotion-completion-dermo') {
                return 'Da li želite da pošaljete izveštaj i završite promociju? Naknadne izmene podataka neće biti moguće.';
            }

            if (this.$route.name === 'new-promotion-base-settings-promo') {
                return 'Dodavanje fotografije pulta je obavezno.';
            }

            return 'Da li ste sigurni da želite da sačuvante promene?';
        },
    },

    methods: {
        accept() {
            this.$emit('accept');
        },

        close() {
            this.$emit('close');
        },
    },
};